/* eslint-disable @typescript-eslint/no-explicit-any */
declare const googlefc: any
export default function manageConsent(): void {
	googlefc.callbackQueue.push({ CONSENT_DATA_READY: () => googlefc.showRevocationMessage() })
}
